import {
  APICallState,
  Selectors,
  useWidgetState,
} from '@eCommerce/frontend-legacy-shared-library';

import OptIn from 'components/OptIn';

export default function OptInScreen() {
  const loadStatus = useWidgetState(
    Selectors.mfaProfileStatusSelector,
  ) as APICallState;

  return <OptIn loadStatus={loadStatus} />;
}
